export const CREDITOR_CONTAINER_TAG_NAME = 'creditor-container';
